/**
 * Parser for Provisioning step template data (Account group)
 */

import type { ParsedField, TemplateAttribute } from './types';

const parseProvisioningStep = (
  attributes: TemplateAttribute[]
): Record<string, ParsedField | TemplateAttribute> => {
  const result: Record<string, ParsedField | TemplateAttribute> = {};

  attributes.forEach((attr) => {
    if (!attr.displayOnUI) {
      return;
    }

    // For CreateAccount, return raw attribute (matches Copilot1 logic)
    if (attr.attributeName === 'externalconnattvalue.CreateAccountJSON') {
      result.CreateAccount = attr;

      return;
    }

    // For other provisioning attributes, return raw attributes
    if (
      attr.attributeName.includes('AccountJSON') ||
      attr.attributeName.includes('AccessJSON')
    ) {
      const stepName =
        attr.attributeName.split('.')[1]?.replace('JSON', '') ||
        attr.attributeName;

      result[stepName] = attr;
    }
  });

  return result;
};

export default parseProvisioningStep;
